import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { MatrixRain } from './MatrixRain';
export function Hero() {
  const scrollToPrecio = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('precio');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-matrix-black px-4 pt-12 md:pt-20 pb-10" data-id="element-108">
      <MatrixRain data-id="element-109" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center mt-8 md:mt-0" data-id="element-110">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-cinzel text-4xl md:text-7xl font-bold text-matrix-cream mb-4 md:mb-6 drop-shadow-[0_0_15px_rgba(0,255,65,0.3)] leading-tight" data-id="element-111">
          
          ¿ESTÁS LISTO PARA JUGAR?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="font-inter text-lg md:text-2xl text-matrix-white max-w-3xl mb-8 md:mb-12 font-light px-2" data-id="element-112">
          
          Un ebook para cuestionar creencias, despertar conciencia y reconectar
          con tu verdad interior.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="relative mb-6 md:mb-8 flex flex-col items-center" data-id="element-113">
          
          <a href="#precio" onClick={scrollToPrecio} className="relative inline-block cursor-pointer" data-id="element-114">
            
            <div className="absolute inset-0 bg-matrix-green blur-[60px] opacity-20 rounded-full" data-id="element-115"></div>
            <img src="https://cdn.magicpatterns.com/uploads/6s418vhVJEZ5z4EspBfbhj/Ebook_EStas_listo_para_jugar_.png" alt="Ebook: ¿Estás listo para jugar?" className="relative z-10 w-64 md:w-96 lg:w-[28rem] rounded-lg shadow-[0_0_30px_rgba(0,255,65,0.4)] animate-float border border-matrix-green/30 hover:shadow-[0_0_40px_rgba(0,255,65,0.6)] transition-shadow duration-300" data-id="element-116" />
            
          </a>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 0.8
        }} className="mt-6 font-inter text-matrix-green/90 text-sm md:text-base font-medium tracking-widest uppercase" data-id="element-117">
            
            ACCESO INMEDIATO · COMPRA SEGURA ↓
          </motion.p>
        </motion.div>

        <motion.a href="#precio" onClick={scrollToPrecio} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} whileHover={{
        scale: 1.05,
        boxShadow: '0 0 25px rgba(0,255,65,0.6)'
      }} whileTap={{
        scale: 0.95
      }} className="inline-block bg-matrix-green text-matrix-black font-inter font-bold text-lg md:text-xl px-8 md:px-10 py-4 rounded-sm uppercase tracking-wider transition-all duration-300 mb-8 md:mb-0" data-id="element-118">
          
          ACCEDER AHORA
        </motion.a>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-6 md:bottom-10 z-10 text-matrix-green animate-bounce hidden md:block" data-id="element-119">
        
        <ChevronDown size={40} className="opacity-70" data-id="element-120" />
      </motion.div>

      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-matrix-dark to-transparent z-0" data-id="element-121"></div>
    </section>;
}